import { Component, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, lastValueFrom, Subscription } from 'rxjs';
import { ElectronicInvoiceInterfaceModel } from 'src/app/models/invoicing/electronic-invoice-interface.model';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import Swal from 'sweetalert2';
import { ElectronicDocumentService } from '../../../../services/invoicing/electronic-document.service';

@Component({
  selector: 'app-send-mail',
  templateUrl: './send-mail.component.html',
  styleUrls: ['./send-mail.component.scss'],
  standalone: false
})
export class SendMailComponent implements OnInit {
  disabledStart: boolean = false;
  dataRecovery: {
    listBranches: any[],
    listEnterprises: any[]
  }
  electronicInvoiceInterfaceContract: ElectronicInvoiceInterfaceModel = new ElectronicInvoiceInterfaceModel();
  nameBranch: string = '';
  nameEnterprise: string = '';
  permissionUpdatable: boolean = false;
  preInvoicingAlerts: PreInvoicingAlertModel[] = [];
  startProcess: boolean = false;
  suscription: Subscription;
  visibleAlerts: boolean = false;


  constructor(
    public config: DynamicDialogConfig,
    @Optional() private ref: DynamicDialogRef,
    private electronicDocumentService: ElectronicDocumentService) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.electronicInvoiceInterfaceContract = inputs.electronicInvoiceInterfaceModel;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.dataRecovery = inputs.dataRecovery
    });
    this.nameBranch = this.dataRecovery.listBranches.find(x => x.value == this.electronicInvoiceInterfaceContract.branchId).label;
    this.nameEnterprise = this.dataRecovery.listEnterprises.find(x => x.value == this.electronicInvoiceInterfaceContract.enterpriseId).label!;
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  cancel() {
    this.ref.close();
  }

  async sendEmail() {
    if (this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId != 0) {
      const response = await firstValueFrom(this.electronicDocumentService.getSendMailAsync(this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId));
      Swal.fire({
        title: 'Atención',
        html: response,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.startProcess = true;
            this.preInvoicingAlerts = await lastValueFrom(this.electronicDocumentService.sendMail(this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId));
            this.visibleAlerts = true;
            const output$ = this.config.data?.output$;
            output$?.next({ type: 'update', payload: this.electronicInvoiceInterfaceContract });
          } catch (error) {
            this.startProcess = false;
            console.error('error al enviar los correos', error)
          }
        } else {
          this.ref.close();
        }
      });
    }
    this.disabledStart = true;
  }

}
